import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/drainage-contact-me'
import {format} from 'utils/index'

export async function getTableData(params = {}) {
    return request(`${api.getTableData.url}?${stringify(params)}`)
}

export async function deleteRecord(payload) {
    return request(format(api.deleteRecord.url, {id: payload.id}), {
        method: api.deleteRecord.type,
    })
}

// 创建联系我
export async function createContactMe(payload) {
    return request(api.createContactMe.url, {
        method: api.createContactMe.type,
        body: payload.body,
    })
}

// 编辑联系我
export async function editContactMe(payload) {
    return request(format(api.editContactMe.url, {id: payload.id}), {
        method: api.editContactMe.type,
        body: payload.body,
    })
}

// 获取联系我详情
export async function getDetails(payload) {
    return request(format(api.getDetails.url, {id: payload.id}))
}

export async function contactWaysExport(payload) {
    return request(
        api.contactWaysExport.url,
        {
            method: api.contactWaysExport.type,
            body: payload.body,
        },
        {
            returnResponse: true,
        },
    )
}
